import { ApiBind, Common } from "./common.model";

/**
 * プレースメント設定で使用する広告リクエストのモデル
 *
 * @exports
 * @extends Common
 */
export class PlacementAdRequest extends Common {

    @ApiBind({ column: 'id' })
    id: number;

    @ApiBind({ column: 'placement_id' })
    placementId: number;

    @ApiBind({ column: 'platform_id' })
    platformId: number;

    @ApiBind({ column: 'ad_format' })
    adFormat: number;

    @ApiBind({ column: 'name' })
    name: string;
  }
